import { render, staticRenderFns } from "./LongueursVente.vue?vue&type=template&id=15141b43&"
import script from "./LongueursVente.vue?vue&type=script&lang=ts&"
export * from "./LongueursVente.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports